import get from 'lodash/get';
import { selectIsAuthenticated } from '../selectors/auth';

/**
 * A util that returns the guideId follow state based on follow states that have changed
 * during the current session or falls back to the initial follow state of the guideItem
 * @param state - redux store state
 * @param guideId - a guide id of the guide item
 * @param initialState - initial follow state of the guideItem
 * @returns {boolean}
 */
const isFollowingGuideId = (state, guideId, initialState) => {
  const changedFollowState = get(
    state,
    ['me', 'changedFavorites', guideId],
    initialState,
  );
  return selectIsAuthenticated(state) && changedFollowState;
};

export default isFollowingGuideId;
